/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/anchor-has-content */

const NavigationDots = ({ active }) => (
  <div className="app__navigation">
    {['home', 'skills', 'work', 'testimonial', 'contact'].map((item, index) => (
      <a
        href={`#${item}`}
        key={item + index}
        className="app__navigation-dot"
        style={active === item ? { backgroundColor: '#FAF3AF' } : {}}
      />
    ))}
  </div>
)

export default NavigationDots
